import { http, HttpResponse } from 'msw';

const baseUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/toc`;

export const tocHandlers = [
  // 注意事項の未読確認
  http.get(`${baseUrl}/is_unread`, async () => {
    const response = {
      unread: false,
    };

    return HttpResponse.json(response);
  }),
  // 注意事項の既読化
  http.post(`${baseUrl}/read`, async () => {
    return HttpResponse.json({ success: true });
  }),
];
